import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import{Box, Grid, Typography}  from '@mui/material';
import { getLogin } from 'redux/actions/authAction';
import { companyDetails } from 'utils/companyDetails';
import { getBranding, loadTenantConfig, rememberTenantId } from 'config/tenantConfig';
import { injectTheme } from 'config/themeInjector';
import { identifyApi } from 'services/AuthService';
import TenantPicker from 'components/tenantPicker/TenantPicker';
import Otp from 'pages/auth/otp/Otp';
import CommonForm from 'components/commonForm/CommonForm';
import QuoteImg from 'assets/images/QuoteImg.svg';

export default function Login() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userLogin = useSelector((state) => state);
  const isLoader = userLogin?.auth?.loading;

  const [onOtp, setOnOtp] = useState(false);

  const handleredirect = () => {
    navigate('/signup');
  };

  const onOtpPage = (val) => {
    setOnOtp(val);
  };

  const loginForm = [
    {
      placeholder: 'Enter your official email',
      required: true,
      type: 'text',
      name: 'email',
      label: 'Official Email',
      star: '*',
      countrycode: false,
    },
  ];

  const [tenantChoices, setTenantChoices] = useState([]);
  const [pendingLogin, setPendingLogin] = useState(null);

  const proceedLogin = (userDetails) => {
    dispatch(getLogin(userDetails, navigate));
  };

  const applyTenant = (tenantId) => {
    rememberTenantId(tenantId);
    // Refresh branding for the chosen tenant (fire-and-forget).
    loadTenantConfig()
      .then(injectTheme)
      .catch(() => {});
  };

  const onLogin = async (data, code) => {
    localStorage.clear();
    const userDetails = {
      platform: 'FrontDeskApp',
      firstName: '',
      lastName: '',
      mobileOrEmail: data.email,
      countryCode: '+91',
      deviceToken: '',
    };

    // Identify-first (common-URL) login: ask which tenant(s) know this user.
    // Any failure or empty result falls through to the normal login flow so
    // subdomain deployments are unaffected.
    try {
      const identifyRes = await identifyApi({
        platform: 'FrontDeskApp',
        mobileOrEmail: data.email,
        countryCode: '+91',
      });
      const tenants =
        identifyRes?.success && Array.isArray(identifyRes.data) ? identifyRes.data : [];
      if (tenants.length === 1) {
        applyTenant(tenants[0].tenantId);
      } else if (tenants.length > 1) {
        setPendingLogin(userDetails);
        setTenantChoices(tenants);
        return; // wait for the user's pick (or cancel)
      }
    } catch (e) {
      // fail-open: proceed with login exactly as before
    }
    proceedLogin(userDetails);
  };

  const onTenantSelect = (tenant) => {
    const userDetails = pendingLogin;
    setTenantChoices([]);
    setPendingLogin(null);
    applyTenant(tenant?.tenantId);
    if (userDetails) proceedLogin(userDetails);
  };

  const onTenantCancel = () => {
    setTenantChoices([]);
    setPendingLogin(null);
  };

  useEffect(() => {
    if (userLogin?.auth?.userLogin?.success) {
      setOnOtp(true);
    } else {
      setOnOtp(false);
    }
  }, [isLoader, userLogin]);

  return (
    <div>
      {onOtp === false && (
        <Box sm={{ flexGrow: 1 }} className="mobileRes height100 loginMain">
          <Grid container className="justifyCenter">
            {/* ---login Part--- */}
            <Grid item sm={6}>
              {/* ---login nav--- */}
              <Box
                sx={{
                  display: { xs: 'none', sm: 'flex' },
                  alignItems: 'center',
                }}
              >
                <Grid
                  container
                  direction="row"
                  justifyContent="flex-start"
                ></Grid>
              </Box>
              {/* ---login input type--- */}
              <div className="loginInput mobileBg">
                <Grid
                  container
                  className="height100 justifyCenter"
                >
                  <Grid
                    item
                    sm={7}
                    container
                    flexDirection={'column'}
                    alignItems={'flex-start'}
                    justifyContent={'center'}
                  >
                    <Box className="mb20">
                      <img src={getBranding().logo || companyDetails?.companyLogo} className="logoImg" alt="otplogo" />
                    </Box>
                    <Box
                      sx={{ paddingLeft: { xs: '0px', sm: '10px' } }}
                      width={'100%'}
                    >
                      <Typography className="fw700 font36 colorPrimary pb20">
                        <span className="colorYellow">Login</span>
                        <span className="bottomDivider"></span>
                      </Typography>
                      <Typography
                        variant={'body1'}
                        className="colorGrey fontInput fw400"
                      >
                        Add your Login details below
                      </Typography>
                      <CommonForm
                        formData={loginForm}
                        button={'Login'}
                        onSubmittBtn={onLogin}
                        loading={isLoader}
                        disabled={isLoader}
                      />
                    </Box>
                  </Grid>
                </Grid>
              </div>
            </Grid>
            {/* ---Image Part--- */}
            <Grid
              item
              sm={6}
              sx={{ display: { xs: 'none', sm: 'flex' } }}
              className="bgImage"
            >
              <Box className="loginBgImg height100">
                <Box className="justifyCenter height100">
                  <Box className="justifyCenter">
                    <Box
                      className="flexDisplay alignFlexStart"
                      flexDirection={'column'}
                    >
                      <img src={QuoteImg} alt="quoteImg" className="quoteImg" />
                      <Typography
                        className="colorWhite fw300"
                        variant={'head2'}
                      >
                        Innovate, Collaborate,
                        <br />
                        Prosper: Redefine Possibilities
                        <br />
                        with our <span className="fw600">{companyDetails?.companyName}</span> Initiative
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>
      )}
      {onOtp && <Otp onOtpPage={onOtpPage} />}
      <TenantPicker
        open={tenantChoices.length > 0}
        tenants={tenantChoices}
        onSelect={onTenantSelect}
        onCancel={onTenantCancel}
      />
    </div>
  );
}
